import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapLocationEditPageComponent from './mapLocationEditPage.component';

let mapLocationEditPageModule = angular.module('mapLocationEditPage', [
  uiRouter
])

.component('mapLocationEditPage', mapLocationEditPageComponent)

.name;

export default mapLocationEditPageModule;
